import React from 'react';

import { observer } from 'mobx-react-lite';
import styled, { css } from 'styled-components';

const Wrapper = styled.div`
  user-select: none;
  ${(p) => !p.disabled && 'cursor: pointer'};
  margin-bottom: 0;
  ${(p) => p.disabled && 'opacity: 0.65'};
  display: flex;
  align-items: center;

  .checkbox-label {
    margin-left: 10px;
    opacity: ${(p) => (!p.fadeLabel ? 1 : '0.65')};
    color: ${(p) => p.theme.checkboxLabelColor || '#7d7f97'};
    font-size: 14px;
  }

  .checkbox {
    position: relative;
    width: 20px;
    height: 20px;
    border: 2px solid ${(p) => (p.checked ? (p.color ? p.color : p.theme.primaryColor) : '#81839b')};
    border-radius: 3px;
    ${(p) => p.checked && `border-color: ${(p) => (p.color ? p.color : p.theme.primaryColor)};`};

    svg {
      position: absolute;
      top: -2px;
      left: -2px;
      path {
        fill: ${(p) => (p.checked ? (p.color ? p.color : p.theme.primaryColor) : 'none')};
        stroke: ${(p) => (p.color ? p.color : p.theme.primaryColor)};
        stroke-width: 2px;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-dasharray: 71px;
        stroke-dashoffset: ${(p) => (p.checked ? '0' : '71px')};
        transition: all 0.6s ease;
      }
      polyline {
        fill: none;
        stroke: #fff;
        stroke-width: 2px;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-dasharray: 18px;
        stroke-dashoffset: ${(p) => (p.checked ? '0' : '18px')};
        transition: all 0.3s ease;
      }
    }

    ${(p) =>
      !p.disabled &&
      css`
        :hover {
          svg > path {
            stroke-dashoffset: 0;
          }
        }
      `};
  }

  > span {
    pointer-events: none;
  }

  input {
    display: none;
  }
`;

export default observer(({ text, checked, onClick, disabled, color, dataCy }) => (
  <Wrapper checked={checked} disabled={disabled} color={color} data-cy={dataCy ? dataCy : null}>
    <input id="cbx" type="checkbox" checked={checked || false} readOnly />
    <div className="checkbox" onClick={disabled ? null : onClick}>
      <svg width="20px" height="20px" viewBox="0 0 20 20">
        <path d="M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z" />
        <polyline points="4 11 8 15 16 6" />
      </svg>
    </div>
    {text && <div className="checkbox-label">{text}</div>}
  </Wrapper>
));
